import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import UnitInfoSkeleton from './UnitInfoSkeleton'

const UnitInfoPlaceholder = () => (
  <UnitInfoSkeleton
    nameSection={
      <LoadingBox width="200px" maxWidth="100%">
        &nbsp;
      </LoadingBox>
    }
    iconSection={<LoadingBox width="100%" height="100%" borderRadius="full" />}
  />
)

export default UnitInfoPlaceholder
